// src/utils/assetLayout.js
// Small helpers so component code stays tidy.

export const getThumbAspect = (asset) => {
  const a = asset?.thumb?.aspect;
  if (typeof a === "number" && a > 0) return a;

  const w = asset?.dimensions?.width;
  const h = asset?.dimensions?.height;
  if (Number(w) > 0 && Number(h) > 0) {
    return Number((Number(w) / Number(h)).toFixed(4));
  }

  // fallback by type (keeps old behavior intact)
  switch (asset?.assetType) {
    case "banner":
      return 16 / 9;
    case "screenshot":
      return 4 / 3;
    default:
      return 1;
  }
};

export const getGridSrcs = (asset) => {
  const u = asset?.thumb?.urls || {};
  const w400 = u["400"] || null;
  const w800 = u["800"] || null;
  return { w400, w800 };
};

// Estimate CSS Grid row span for a tile.
// - trackW: column width in px (your grid uses 200)
// - baseRow: grid-auto-rows unit in px (we'll set to 8)
// - gap: gap between rows in px (your grid uses 24)
// - border: total vertical border in px on the card (1px top + bottom)
export const computeGridRowSpan = ({
  aspect,          // width / height
  trackW = 200,
  baseRow = 8,
  gap = 24,
  border = 2,
}) => {
  const h = Math.max(1, Math.round(trackW / Math.max(aspect, 0.01)));
  const total = h + border;          // include 1px top + 1px bottom
  const span = Math.ceil((total + gap) / (baseRow + gap));
  return Math.max(1, span);
};

// Consider something "square-ish" if aspect is near 1:1
export const isSquareish = (aspect, tol = 0.15) =>
  Math.abs(Number(aspect || 0) - 1) <= tol;

// Consider something "small-ish" if the smaller side is below a threshold
export const isSmallish = (asset, px = 320) => {
  const w = Number(asset?.dimensions?.width || 0);
  const h = Number(asset?.dimensions?.height || 0);
  if (!w || !h) return false;
  return Math.min(w, h) <= px;
};
